import React, { useState, useEffect } from "react"
import { Card, Button, Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"
import axios from "axios"

const LeaveApp = () => {
  const token = JSON.parse(localStorage.getItem("Token"))

  const [data, setData] = useState()

  const getLeaveAuth = async () => {
    try {
      await axios({
        method: "GET",
        url: "https://marcopolo.prisms.in/api/leave/get-leave-auth-setting",
        headers: {
          Authorization: token,
        },
      }).then(res => {
        console.log(res.data)
        setData(
          res.data.leaveAuthReportSetting[0].values
            .split(",")
            .map(item => item.trim())
        )
      })
    } catch (error) {
      // toast.success("something went wrong")
    }
  }

  useEffect(() => {
    getLeaveAuth()
  }, [])

  // console.log(data)
  return (
    <div className="page-content">
      <Container className="">
        <Card
          className="shadow-sm p-4"
          style={{
            borderRadius: "4px",
            backgroundColor: "#ffffff",
            maxWidth: "100%",
            margin: "auto",
          }}
        >
          <h1
            className="text-center mt-2 mb-4 fs-2"
            style={{ color: "#3c3c3c", fontWeight: "600" }}
          >
            Teacher Leave
          </h1>

          <Row className="d-flex justify-content-center flex-column align-items-center justify-content-center">
            <Col xs="auto" className="mt-4 mb-3">
              <Link to={"/teacher/apply-leave"}>
                <Button
                  color="primary"
                  className="px-4 py-2"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "200px",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                  }}
                  onMouseEnter={e => {
                    e.target.style.transform = "scale(1.05)"
                    e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.2)"
                  }}
                  onMouseLeave={e => {
                    e.target.style.transform = "scale(1)"
                    e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  Apply Leave
                </Button>
              </Link>
            </Col>

            <Col xs="auto" className="mt-3 mb-4">
              <Link to={"/teacher/leave-history"}>
                <Button
                  color="dark"
                  className="px-4 py-2"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "200px",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                  }}
                  onMouseEnter={e => {
                    e.target.style.transform = "scale(1.05)"
                    e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.2)"
                  }}
                  onMouseLeave={e => {
                    e.target.style.transform = "scale(1)"
                    e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  Leave Report
                </Button>
              </Link>
            </Col>

            {data && (
              <Col xs="auto" className="mt-1 mb-5">
                <Link to={"/teacher/leave-authority"}>
                  <Button
                    color="dark"
                    className="px-4 py-2"
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      width: "200px",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    }}
                    onMouseEnter={e => {
                      e.target.style.transform = "scale(1.05)"
                      e.target.style.boxShadow =
                        "0px 6px 18px rgba(0, 0, 0, 0.2)"
                    }}
                    onMouseLeave={e => {
                      e.target.style.transform = "scale(1)"
                      e.target.style.boxShadow =
                        "0px 4px 12px rgba(0, 0, 0, 0.1)"
                    }}
                  >
                    Leave Authority
                  </Button>
                </Link>
              </Col>
            )}
          </Row>
        </Card>
      </Container>
    </div>
  )
}

export default LeaveApp
